import { Injectable } from '@angular/core';
import { ListHelperService, PopUpService, ProfileService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { MarsMessagesService } from './mars-messages.service';

@Injectable()
export class MarsMessagesListService {
  userRole: any;
  dataSource: TableDatasource;

  constructor(
    public translate: TranslateService,
    public listHelper: ListHelperService,
    public popupService: PopUpService,
    public marsMessagesService: MarsMessagesService
  ) {}

  async getDatasource(listId, options: any = {}) {
    const dataSource = new TableDatasource({
      sort: '-created_at',
      columns: await this.getColumns(),
      load: (props) => this.fetch(props),
      ...options
    });
    await dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  fetch({ page, limit, sort, search, filters }) {
    const paginationOptions = {
      page,
      limit,
      sort,
      search,
      ...filters
    };
    return this.marsMessagesService.fetch(paginationOptions).then((response) => response);
  }

  async getColumns() {
    const columns = [
      {
        source: 'data.message',
        label: this.translate.instant('groupMessages.message'),
        dataType: DataTypes.string,
        sortable: true
      },
      {
        source: 'created_at',
        label: this.translate.instant('groupMessages.date'),
        dataType: DataTypes.datetime,
        style: { width: '150px' },
        sortable: true
      }
    ];
    return columns;
  }
}
